import { email } from '@rxweb/reactive-form-validators';

export class ForgotPassword {
  @email()
  email: string;
}
